'use strict';

var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");

/**
 * Configurazione di un campo file
 * Imposta ngModel con il base64 del contenuto del file 
 * 
 * @class
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {type} Valida
 * @returns {undefined}
 */
function BSSFile(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bssfile',
        template: require("./bssfile.html"),
        defaultOptions: {
            ngModelElAttrs: {
                'fileread': "bssfile.uploadFile",
                'cssCategory': 'bssfile',
            }
        },
        controller: ["$scope", "$filter", "FileUploader", "ErrorManager", "LoginService", require("./BssFileController")] //definire il controller
    }));
};

module.exports = BSSFile;